import { render, staticRenderFns } from "./step_questions.vue?vue&type=template&id=5096754d&scoped=true"
import script from "./step_questions.vue?vue&type=script&lang=js"
export * from "./step_questions.vue?vue&type=script&lang=js"
import style0 from "./step_questions.vue?vue&type=style&index=0&id=5096754d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5096754d",
  null
  
)

export default component.exports